import { Checkbox } from "@mui/material";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import BasicSelect from "components/BasicInputs/BasicSelect";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import shortid from "shortid";
import useUpdatePrice from "../data";

export interface AddPlanProps {
  submit?: boolean;
  plan?: Plan;
  onSubmit: (fd: any) => void;
}

export default function AddPlan({ onSubmit, plan, submit }: AddPlanProps) {
  const business = useSelector((state: any) => state.businessReducer.business.business);
  const { plans } = useUpdatePrice();
  const { businessCurrencies: C, currencies: CUR } = useSelector((x: any) => x).currencyReducer;
  const businessCurrencies = [CUR.find((c: any) => c.id === business.default_currency_id), ...C];
  const currencies = businessCurrencies
    ? businessCurrencies.map((x: any) => {
        let en = x.en_title;
        let fa = x.fa_title;
        if (x.id === 1) {
          en = "IRR";
          fa = "ریال ایران";
        }
        return { ...x, label: `( ${fa} - ${en} )`, value: x.id };
      })
    : [];
  const [fd, setFd] = useState<Plan>({
    ...(plan || { ind: shortid.generate(), title: "",code:"", currency: currencies[0] }),
  });
  const [depend, setDepend] = useState(false);
  const isEdit = Boolean(plan);

  useEffect(() => {
    if (submit) onSubmit(fd);
  }, [submit]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <BasicTextInput
        label="عنوان*"
        val={fd.title}
        onChange={(val) => setFd((x) => ({ ...x, title: `${val}` }))}
      />
      <BasicTextInput
        label="کد*"
        val={fd.code}
        onChange={(val) => setFd((x) => ({ ...x, code: `${val}` }))}
      />
      {/* <BasicSelect
        label="واحد پول"
        options={currencies}
        defaultValue={fd?.currency?.id}
        onChange={(val, option) => setFd((x) => ({ ...x, currency: option }))}
        withSearch
        noVirtual
      /> */}
      {!isEdit && (
        <div>
          <div>
            <Checkbox checked={depend} onChange={() => setDepend((x) => !x)} />
            <span>بر اساس قیمت های دیگر</span>
          </div>
          {depend && (
            <BasicSelect
              options={plans.map((x) => ({ ...x, ind: undefined, label: x.title }))}
              noVirtual
              
              onChange={(val) => {
                setFd((x) => ({
                  ...x,
                  dependOn: { secondPricePlanId: val, secondPricePlanPercent: 100 },
                }));
              }}
            />
          )}
        </div>
      )}
      {Boolean(fd.dependOn) && (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <BasicTextInput
            type="number"
            key={"secondPricePlanPercent"}
            label="درصد"
            val={fd.dependOn?.secondPricePlanPercent}
            onChange={(val) =>
              typeof val === "number" &&
              setFd((x) => ({
                ...x,
                dependOn: x.dependOn ? { secondPricePlanId: x.dependOn.secondPricePlanId, secondPricePlanPercent: val } : undefined,
              }))
            }
          />
        </div>
      )}
    </div>
  );
}
